/* unplugin-vue-components disabled */import script from "./UserAvator.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAvator.vue?vue&type=script&setup=true&lang=ts"

import "./UserAvator.vue?vue&type=style&index=0&id=2ac4db2d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac4db2d"]])

export default __exports__